import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ_ITEMS } from "../data/cabins";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-[#f7f5f0]"
    >
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <p className="text-sm uppercase tracking-[0.2em] text-[#b55a30] font-bold mb-3">
          Perguntas frequentes
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#1a3622] leading-tight">
          Tudo o que você precisa saber.
        </h2>

        <Accordion
          type="single"
          collapsible
          className="mt-10 w-full"
          data-testid="faq-accordion"
        >
          {FAQ_ITEMS.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="border-[#d1cfc3]"
            >
              <AccordionTrigger
                data-testid={`faq-q-${idx}`}
                className="text-base sm:text-lg font-bold text-[#1a3622] py-5 hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4a6b53] leading-relaxed text-base pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
